import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

export const words = () => {
  const word = [
    FindLangKey('current-patient-page-title'),
    FindLangKey('general-public-patients-list'),
    FindLangKey('new-referral-navbar-title'),
    FindLangKey(
      'current-patients-patient-actions-list-service-confer'
    ),
    FindLangKey('general-public-performance-report'),
    FindLangKey('add-new-confer-navbar-title'),
    FindLangKey('edit-confer-service-navbar-title'),
    FindLangKey('add-medical-font-navbar-title'),
    FindLangKey('general-public-refer-to'),
    FindLangKey('electronic-forms-edit-form-title-navbar'),
    FindLangKey('lab-test-result-navbar-title-lab'),
    FindLangKey('main-menu-drawer-link-freeze-contract'),
    FindLangKey('main-menu-button-get-appointment'),
    FindLangKey('main-menu-button-appointments'),
    FindLangKey('main-menu-button-invoice-receipt'),
    FindLangKey('page-title-quartering'),
    FindLangKey('main-menu-button-lab-actions'),
    FindLangKey('patologoy-lab-route-title'),
    FindLangKey('genral-public-btn-label-download-file'),
    FindLangKey('main-menu-button-patient-send-file'),
    FindLangKey('main-menu-button-patient-send-file'),
    FindLangKey('main-menu-button-pacs-images'),
    FindLangKey('user-survey-route-title'),
    FindLangKey('patient-cartable-navbar-title'),
    FindLangKey('patients-for-visit-navbar-title'),
    FindLangKey(
      'current-patients-patient-actions-service-summary'
    ),
    FindLangKey('save-patients-for-visit-navbar-title'),
    FindLangKey('main-menu-drawer-wallet-button'),
    FindLangKey(
      'main-menu-settings-drawer-nobat-prefrences'
    ),
    FindLangKey('genral-public-label-wep-app-settings'),
    FindLangKey(
      'genral-public-label-customization-settings'
    ),
    FindLangKey('freeze-contracts-btn-upload-bank-receipt'),
  ];
  return word;
};
